import { forwardRef as f } from "react";
function o(r) {
  return f(r);
}
export { o as forwardAsTagRef };